export default {
    icon: "el-icon-s-home",
    title: "店铺选择",
    name: "shopSelect",
    timestamp: new Date().getTime(),
    setUp: {
        tabVal: 0
    },
    bgColor: {
        title: "背景颜色(渐变)",
        name: "bgColor",
        default: [
            {
                item: "#F62C2C"
            },
            {
                item: "#F96E29"
            }
        ],
        color: [
            {
                item: "rgba(29,176,252,1)"
            },
            {
                item: "rgba(64,209,244,1)"
            }
        ]
    },
    shopSelectConfig: {
        title: '选择器数据配置',
        selectUrl: '',
        selectName: ''
    },
    titleColor: {
        title: '文字颜色',
        name: 'themeColor',
        default: [
            {
                item: '#333333'
            }
        ],
        color: [
            {
                item: 'rgba(51,51,51,1)'
            }
        ]
    },
    prConfig: {
        title: "背景边距",
        val: 8,
        min: 0
    },
    mbConfig: {
        title: "页面间距",
        val: 0,
        min: 0
    },
    id: new Date().getTime()
}